import React, { createContext, useState, useContext } from "react";
import { FaoBuilderContext } from "./FaoBuilderContext";
import apiRoot from "api/apiRoot";

export const FaoRegimeContext = createContext();

export const FaoRegimeStore = ({ children }) => {
  const [currentlyEditing, setCurrentlyEditing] = useState(0);
  const [matrices, setMatrices] = useState([]);
  const [dimensions_x, setDimensionsX] = useState([]);
  const [dimensions_y, setDimensionsY] = useState([]);
  const [cellMetrics, setCellMetrics] = useState({
    meritAward: true,
    needMetric: true,
    capDollar: true,
    capPercent: false,
  });

  const [selectedX, setSelectedX] = useState("");
  const [selectedY, setSelectedY] = useState("");
  const [lastValidatedDate, setLastValidatedDate] = useState(null);
  const { modelConfig, formatDate } = useContext(FaoBuilderContext);

  const [columnOptions, setColumnOptions] = useState([]);

  const compare = (a, b) => {
    if (a.value < b.value) {
      return -1; // a should come before b
    }
    if (a.value > b.value) {
      return 1; // b should come before a
    }
    return 0; // a and b are equal
  };
  const fetchValidateDate = async () => {
    try {
      const response = await apiRoot.get(`api/fao-regime/validation-date`, {
        params: { modelId: modelConfig.id },
      });
      let date = response.data[0] ? response.data[0]["last_altered"] : "";
      formatDate(date, setLastValidatedDate);
    } catch (error) {
      console.log(error);
    }
  };
  const value = {
    currentlyEditing,
    setCurrentlyEditing,
    matrices,
    setMatrices,
    dimensions_x,
    setDimensionsX,
    dimensions_y,
    setDimensionsY,
    cellMetrics,
    setCellMetrics,
    selectedX,
    setSelectedX,
    selectedY,
    setSelectedY,
    columnOptions,
    setColumnOptions,
    compare,
    lastValidatedDate,
    setLastValidatedDate,
    fetchValidateDate,
  };

  return (
    <FaoRegimeContext.Provider value={value}>
      {children}
    </FaoRegimeContext.Provider>
  );
};
